import React from 'react';
import Icon from './Icon';

const ViewQuestionModal = ({ question, onClose }) => {
    if (!question) return null;

    // Helper to format date
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };
    
    const formatDateTime = (timestamp) => {
        if (!timestamp) return 'N/A';
        return new Date(timestamp.seconds * 1000).toLocaleString();
    }

    return (
        // Modal backdrop
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-40" onClick={onClose}>
            {/* Modal content */}
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl p-6 relative animate-fade-in" onClick={e => e.stopPropagation()}>
                {/* Close button */}
                <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors">
                    <Icon name="X" />
                </button>

                <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b pb-3">Question Details</h2>

                <div className="space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                    <div>
                        <p className="text-sm font-semibold text-slate-600">Question Text</p>
                        <p className="text-slate-800">{question.text}</p>
                    </div>

                    {question.tags && question.tags.length > 0 && (
                        <div>
                            <p className="text-sm font-semibold text-slate-600">Tags</p>
                            <div className="flex flex-wrap gap-2 mt-1">
                                {question.tags.map(tag => (
                                    <span key={tag} className="bg-indigo-100 text-indigo-700 text-xs font-medium px-2.5 py-1 rounded-full">{tag}</span>
                                ))}
                            </div>
                        </div>
                    )}

                    <div>
                        <p className="text-sm font-semibold text-slate-600">Status</p>
                        <p className="text-slate-800 capitalize">{question.status.replace('-', ' ')}</p>
                    </div>
                    
                    <div>
                        <p className="text-sm font-semibold text-slate-600">Assigned To</p>
                        <p className="text-slate-800">{question.assignedToName || 'N/A'}</p>
                    </div>

                    <div>
                        <p className="text-sm font-semibold text-slate-600">Due Date</p>
                        <p className="text-slate-800">{formatDate(question.dueDate)}</p>
                    </div>
                    
                    <div>
                        <p className="text-sm font-semibold text-slate-600">Answered On</p>
                        <p className="text-slate-800">{formatDateTime(question.answeredAt)}</p>
                    </div>

                    {question.answer && (
                         <div>
                            <p className="text-sm font-semibold text-slate-600">Answer</p>
                            <div className="prose prose-slate max-w-none mt-1 p-3 border rounded-md bg-slate-50 ql-editor" dangerouslySetInnerHTML={{ __html: question.answer }} />
                        </div>
                    )}

                    {question.feedback && (
                         <div>
                            <p className="text-sm font-semibold text-slate-600">Feedback</p>
                            <div className="mt-1 p-3 border rounded-md bg-slate-50">
                                <p className="text-slate-700 italic">"{question.feedback}"</p>
                            </div>
                        </div>
                    )}
                </div>

                 <div className="mt-6 pt-4 border-t flex justify-end">
                    <button onClick={onClose} className="font-semibold py-2 px-4 rounded-md bg-slate-200 hover:bg-slate-300 text-slate-800 transition-colors">Close</button>
                </div>
            </div>
        </div>
    );
};

export default ViewQuestionModal;